import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import PATHS from "../../routes/Paths";
import {
    facebook,
    flag,
    globe,
    headerlogo,
    instagram,
    less,
    linkedin,
    location,
    more,
    phone1,
    shield,
    twitter,
    youtube,
} from "../../assets/imagesPath";

const Navbar = () => {
    const location = useLocation();

    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [isDropdownTrue, setIsDropdownTrue] = useState(false);
    const menuRef = useRef(null);

    useEffect(() => {
        setIsMenuOpen(false);
    }, [location]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setIsMenuOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const navigate = useNavigate();
    const handleScroll = (section) => {
        navigate('/services');
        setTimeout(() => {
            const targetSection = document.getElementById(section);
            if (targetSection) {
                targetSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }, 100);
    };
    return (
        <header className="sticky top-0 z-50">
            <div
                className={`relative ${isDropdownOpen ? "bg-white shadow-md" : "bg-[#173363]"
                    } text-white py-2`}
            >
                <div className="flex items-center gap-3 ml-[5rem] smallScreens:ml-2 h-[24px]">
                    <img src={flag} alt="" className="h-[12px] smallScreens:h-4" />
                    <p
                        className={`text-lg smallScreens:text-[1rem] cursor-pointer underline z-10 flex items-center ${isDropdownOpen ? "text-black" : ""
                            }`}
                        onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                    >
                        Official Website of the Small Business Accounting & Advisory
                        Administration
                        <img
                            src={isDropdownOpen ? less : more}
                            alt=""
                            className={`h-[24px] ${isDropdownOpen ? "" : "invert"}`}
                        />
                    </p>
                </div>

                {isDropdownOpen && (
                    <div
                        className={`flex items-center smallScreens:flex-col gap-20 mt-10 mb-5 ml-[5rem] smallScreens:ml-4 ${isDropdownOpen ? "text-black" : ""
                            }`}
                    >
                        <div className="flex items-center gap-3">
                            <img src={globe} alt="" className="h-[4rem] smallScreens:h-[3rem]" />
                            <div>
                                <h3 className="text-2xl smallScreens:text-lg">
                                    Official Website of the Small Business Accounting & Advisory
                                    Administration
                                </h3>
                                <p className="text-lg smallScreens:text-sm z-10">
                                    This is the official website of SBAAA.org, the trusted source
                                    for small business accounting and advisory services.
                                </p>
                            </div>
                        </div>

                        <div className="flex items-center gap-3">
                            <img
                                src={shield}
                                alt=""
                                className="h-[4rem] smallScreens:h-[3rem]"
                            />
                            <div>
                                <h3 className="text-2xl smallScreens:text-lg">
                                    Secure .org websites. use HTTPS
                                </h3>
                                <p className="text-lg smallScreens:text-sm z-10">
                                    A lock ( 🔒 ) or https:// means you’ve safely connected to
                                    SBAAA.org. Share sensitive information only on this official
                                    and secure website.
                                </p>
                            </div>
                        </div>
                    </div>
                )}

                {!isDropdownOpen && (
                    <div className="absolute top-[.9rem] w-full flex items-center justify-center smallScreens:hidden">
                        <div className="overflow-hidden relative w-[25%] smallScreens:w-[80%]">
                            <div className="flex animate-marqueeHeader whitespace-nowrap">
                                <p className="text-center text-lg font-medium mx-4">
                                    Limited time: Get 40% off 2024 catch-up bookkeeping—$199/mo
                                    (regularly $349)!
                                </p>
                                <p className="text-center text-lg font-medium mx-4">
                                    Limited time: Get 40% off 2024 catch-up bookkeeping—$199/mo
                                    (regularly $349)!
                                </p>
                                <p className="text-center text-lg font-medium mx-4">
                                    Limited time: Get 40% off 2024 catch-up bookkeeping—$199/mo
                                    (regularly $349)!
                                </p>
                                <p className="text-center text-lg font-medium mx-4">
                                    Limited time: Get 40% off 2024 catch-up bookkeeping—$199/mo
                                    (regularly $349)!
                                </p>
                            </div>
                        </div>
                    </div>
                )}
            </div>

            <div className="bg-white shadow-md">
                <div className="mx-auto flex items-center justify-between h-[85px] px-6 py-3 lg:px-[12%] smallScreens:justify-center">
                    <Link to={PATHS.home}>
                        <div className="flex items-center">
                            <img
                                src={headerlogo}
                                alt="Logo"
                                className="cursor-pointer h-28 smallScreens:h-24"
                            />
                        </div>
                    </Link>

                    <button
                        className="md:hidden block text-gray-800 focus:outline-none absolute left-[1rem]"
                        onClick={() => setIsMenuOpen(!isMenuOpen)}
                    >
                        <svg
                            className="h-12 w-12"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M4 6h16M4 12h16M4 18h16"
                            ></path>
                        </svg>
                    </button>

                    <nav className="hidden md:flex space-x-16 pt-20 text-[1.6rem] font-medium text-gray-800">
                        <Link to={PATHS.home} className="hover:text-[#173363]">
                            Home
                        </Link>
                        <Link to={PATHS.aboutUs} className="hover:text-[#173363]">
                            About
                        </Link>
                        <div className="relative group">

                            <Link
                                to="#"
                                className="hover:text-[#173363] flex items-center !mr-7"
                            >
                                Services
                                <svg
                                    className="w-5 h-5 ml-2 mt-1 text-gray-800 transition-transform group-hover:rotate-180"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="2"
                                        d="M19 9l-7 7-7-7"
                                    />
                                </svg>
                            </Link>
                            <div className="py-10">
                                <div className="absolute -left-9 hidden group-hover:block rounded-xl text-start bg-[#173363] shadow-lg w-80 rounded-b-xl">
                                    <Link
                                        to={PATHS.services}
                                        onClick={() => handleScroll('business-advisory')}
                                        className="block hover:bg-[#F2F2F282] rounded-md border-b border-white  px-8 py-3 text-white"
                                    >
                                        Business Advisory
                                    </Link>
                                    <Link
                                        to={PATHS.services}
                                        onClick={() => handleScroll('bookkeeping')}
                                        className="block hover:bg-[#F2F2F282] rounded-md border-b border-white px-8 py-3 text-white"
                                    >
                                        Bookkeeping
                                    </Link>
                                    <Link
                                        to={PATHS.services}
                                        onClick={() => handleScroll('establish-business')}
                                        className="block hover:bg-[#F2F2F282] rounded-md border-b border-white px-8 py-3 text-white"
                                    >
                                        Establish Business
                                    </Link>
                                    <Link
                                        to={PATHS.services}
                                        onClick={() => handleScroll('business-formation-support')}
                                        className="block hover:bg-[#F2F2F282] rounded-md border-b border-white px-8 py-3 text-white"
                                    >
                                        Business Formation
                                    </Link>
                                    <Link
                                        to={PATHS.businessSupport}
                                        className="block hover:bg-[#F2F2F282]  rounded-md  border-b border-white px-8 py-3 text-white"
                                    >
                                        Business Support
                                    </Link>
                                </div>
                            </div>

                        </div>

                        <Link to={PATHS.pricing} className="hover:text-[#173363] !ml-7">
                            Pricing
                        </Link>
                        <Link to={PATHS.contactUs} className="hover:text-[#173363]">
                            Contact
                        </Link>
                    </nav>

                </div>

                <div
                    ref={menuRef}
                    className={`fixed top-0 left-0 h-full w-[75%] bg-[#173363] shadow-lg transform ${isMenuOpen ? "translate-x-0" : "-translate-x-full"
                        } transition-transform duration-300 ease-in-out z-50`}
                >
                    <button
                        className="absolute top-6 left-7 text-white focus:outline-none"
                        onClick={() => setIsMenuOpen(false)}
                    >
                        <svg
                            className="h-8 w-8"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M6 18L18 6M6 6l12 12"
                            ></path>
                        </svg>
                    </button>
                    <nav className="flex flex-col space-y-10 items-start ml-8 mt-20 py-4 pb-40">
                        <Link
                            to={PATHS.home}
                            className="block w-[calc(100%-20px)] hover:text-[#173363] text-2xl text-white border-b border-white pr-7 pb-2"
                        >
                            Home
                        </Link>
                        <Link
                            to={PATHS.aboutUs}
                            className="block w-[calc(100%-20px)] hover:text-[#173363] text-2xl text-white border-b border-white pr-7 pb-2"
                        >
                            About
                        </Link>
                        <div className="relative w-full">
                            <button
                                onClick={() => setIsDropdownTrue(!isDropdownTrue)} // Toggle dropdown on click
                                className=" w-[calc(100%-20px)] text-2xl text-white border-b border-white pr-7 pb-2 text-left flex items-center"
                            >
                                Services
                                <svg
                                    className="w-5 h-5 ml-2 text-white transition-transform group-hover:rotate-180"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="2"
                                        d="M19 9l-7 7-7-7"
                                    />
                                </svg>
                            </button>

                            {isDropdownTrue && (
                                <div className="bg-[#173363]  rounded-lg mt-2 w-full mx-auto">
                                    <Link
                                        to={PATHS.services}
                                        onClick={() => handleScroll("business-advisory")}
                                        className="block hover:bg-[#F2F2F282]  py-2 text-white border-white"
                                    >
                                        Business Advisory
                                    </Link>
                                    <Link
                                        to={PATHS.services}
                                        onClick={() => handleScroll("bookkeeping")}
                                        className="block hover:bg-[#F2F2F282]  py-2 text-white border-white"
                                    >
                                        Bookkeeping
                                    </Link>
                                    <Link
                                        to={PATHS.services}
                                        onClick={() => handleScroll("business-formation-support")}
                                        className="block hover:bg-[#F2F2F282]  py-2 text-white border-white"
                                    >
                                        Business Formation
                                    </Link>
                                    <Link
                                        to={PATHS.services}
                                        onClick={() => handleScroll("establish-business")}
                                        className="block hover:bg-[#F2F2F282]  py-2 text-white border-white"
                                    >
                                        Establish Business
                                    </Link>
                                    <Link
                                        to={PATHS.businessSupport}
                                        className="block hover:bg-[#F2F2F282]  py-2 text-white"
                                    >
                                        Business Support
                                    </Link>
                                </div>
                            )}
                        </div>

                        {/* <Link
                            to={PATHS.services}
                            className="block w-[calc(100%-20px)] hover:text-[#173363] text-2xl text-white border-b border-white pr-7 pb-2"
                        >
                            Services
                        </Link> */}
                        <Link
                            to={PATHS.pricing}
                            className="block w-[calc(100%-20px)] hover:text-[#173363] text-2xl text-white border-b border-white pr-7 pb-2"
                        >
                            Pricing
                        </Link>
                        <Link
                            to={PATHS.contactUs}
                            className="block w-[calc(100%-20px)] hover:text-[#173363] text-2xl text-white border-b border-white pr-7 pb-2"
                        >
                            Contact
                        </Link>
                    </nav>


                </div>
            </div>
        </header>
    );
};

export default Navbar;